import { Flex, Box, HStack, For } from 'shared';

import { IFinalSprint } from 'features/sprint/config/types';
import { useSprints } from 'features/sprint/hooks';

import { Typography } from 'shared/components/Typography';

type TChallengeCardSprints = {
  sprintIds: string[];
  currentSprintId: string;
};

export const ChallengeCardSprints = ({
  sprintIds,
  currentSprintId,
}: TChallengeCardSprints) => {
  let challengeAppearedInSprintsCount = 0;
  const { data: allSprints } = useSprints();
  const sprintAppearance: { [key: string]: boolean } = {};
  const latestSprints: IFinalSprint[] = allSprints.slice(0, 10);
  for (const sprint of latestSprints) {
    const appeared = sprintIds.includes(sprint.sprintId);
    sprintAppearance[sprint.sprintId] = appeared;
    if (appeared) {
      challengeAppearedInSprintsCount++;
    }
  }
  return (
    <Flex flexDirection="column" gap="4px" pt="4px">
      <HStack gap="4px" flexDirection="row-reverse" justifyContent="flex-end">
        <For each={latestSprints}>
          {(sprint: IFinalSprint) => (
            <SprintIndicator
              key={sprint.sprintId}
              isAppeared={sprintAppearance[sprint.sprintId]}
              isCurrentSprint={sprint.sprintId === currentSprintId}
            />
          )}
        </For>
      </HStack>
      <Typography type="small" color="gray">
        Appeared in {challengeAppearedInSprintsCount}/{allSprints.length}{' '}
        sprints
      </Typography>
    </Flex>
  );
};

const SprintIndicator = ({
  isAppeared,
  isCurrentSprint,
}: {
  isAppeared: boolean;
  isCurrentSprint: boolean;
}) => (
  <Box
    w={isCurrentSprint ? '14px' : '10px'}
    h={isCurrentSprint ? '14px' : '10px'}
    bg={isAppeared ? 'var(--fgInteractive)' : 'var(--bgCompSecondaryMid)'}
    borderRadius="50%"
    border={isCurrentSprint ? '2px solid var(--fgPrimaryInverse)' : 'none'}
    position="relative"
    boxSizing="border-box"
    css={
      isCurrentSprint
        ? {
            '&::after': {
              content: '""',
              position: 'absolute',
              top: '-2px',
              left: '-2px',
              width: '14px',
              height: '14px',
              border: '1px solid var(--fgInteractive)',
              borderRadius: '50%',
              boxSizing: 'border-box',
            },
          }
        : {}
    }
  />
);
